<template>
    <li :class="className"
        style="-moz-user-select: none; -webkit-user-select: none; -ms-user-select:none; user-select:none;-o-user-select:none;"
        unselectable="on"
        onselectstart="return false;"

        :draggable="status==2"
        @dragstart="dragStart"
        @dragend.prevent="dragEnd"
        @dragover.prevent="dragOver"
        @dragleave.prevent="dragLeave"
        @drop.prevent="dropped">

        <template v-if="status!==2">
            Drag & drop the task you think you would <strong>perform {{ordinalNumbers[position-1]}} best</strong> here
        </template>
        <template v-else>
            <div class="item-wrapper">
                <span class="letter">{{droppedLetter}}</span><span class="text">{{droppedText}}</span>
            </div>
        </template>

    </li>


</template>

<script>
    export default {
        mounted() {
            let vm = this;
            this.position = this.index;

            prolitEvents.$on('QuestionReset', ev => {
                if (vm.droppedStatementVariable === ev) {
                    vm.status = 0;
                    vm.droppedStatementVariable = '';
                    vm.droppedText = '';
                    vm.droppedLetter = '';
                }
            });

            prolitEvents.$on('SwitchedTask', ev => {
                if (this.droppedStatementVariable === ev.element) {
                    let payload = JSON.parse(ev.values);
                    this.droppedLetter = payload.letter;
                    this.droppedStatementVariable = payload.statementVariable;
                    this.droppedText = payload.text;
                    this.status = payload.text === '' ? 0 : 2;
                    prolitEvents.$emit('DroppedTask', {
                        element: payload.statementVariable,
                        value: vm.values[vm.index - 1],
                    });
                }
            });

            prolitEvents.$on('AnswerFromDB', ev => {
                let data = JSON.parse(ev.data);
                if (this.values[this.position-1] === data.value) {
                    this.droppedLetter = data.letter;
                    this.droppedStatementVariable = data.statementVariable;
                    this.droppedText = data.text;
                    this.status = 2;
                    prolitEvents.$emit('DroppedTask', {
                        element: data.statementVariable,
                        value: vm.values[vm.index - 1],
                    });
                }
            });
        },
        props: {
            index: {
                required: true,
            }
        },
        data() {
            return {
                ordinalNumbers: ['1st', '2nd', '3rd', '4th', '5th', '6th', '7th', '8th', '9th', '10th'],
                values: [10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
                position: 0,
                status: 0, //0 initial 1 drag over 2 drag dropped
                classNames: ['', 'on-dragged', 'dragged'],

                droppedLetter: "",
                droppedStatementVariable: "",
                droppedText: ""
            }
        },
        computed: {
            className() {
                return this.classNames[this.status];
            },
            dataToTransfer() {
                return JSON.stringify({
                    letter: this.droppedLetter,
                    statementVariable: this.droppedStatementVariable,
                    text: this.droppedText,
                    dragFrom: 'answers',
                });
            }
        },
        methods: {
            dragStart(ev) {
                ev.dataTransfer.setData('text', this.dataToTransfer);
            },
            dragEnd(ev) {

            },
            dragOver(ev) {
                this.status = 1; // drag over
            },
            dragLeave() {
                this.status = this.droppedText !== "" ? 2 : 0;
            },
            dropped(ev) {
                let vm = this;
                let payload = JSON.parse(ev.dataTransfer.getData('text'));

                if (payload.dragFrom === 'questions') {
                    if(this.droppedStatementVariable!==""){
                        prolitEvents.$emit('QuestionReset', this.droppedStatementVariable);
                    }
                    this.droppedLetter = payload.letter;
                    this.droppedStatementVariable = payload.statementVariable;
                    this.droppedText = payload.text;
                    this.status = 2;
                    prolitEvents.$emit('DroppedTask', {
                        element: payload.statementVariable,
                        value: vm.values[vm.index - 1],
                    });
                    return false;
                }

                prolitEvents.$emit('SwitchedTask', {
                    element: payload.statementVariable,
                    values: vm.dataToTransfer,
                    status: vm.status,
                });

                this.droppedLetter = payload.letter;
                this.droppedStatementVariable = payload.statementVariable;
                this.droppedText = payload.text;
                this.status = 2;

                prolitEvents.$emit('DroppedTask', {
                    element: payload.statementVariable,
                    value: vm.values[vm.index - 1],
                });

            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/views/assessments/skills/SkillsAnswers.vue